import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmActionComponent } from 'src/app/app-layout/modal-confirm-action/modal-confirm-action.component';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { ToastService } from 'src/app/services/toast.service';
import { BudgetCreationModalComponent } from 'src/app/user/order/budget/budget-creation-modal/budget-creation-modal.component';
import { UnlinkProjectComponent } from 'src/app/user/order/budget/project-management/unlink-project/unlink-project.component';
import { BudgetService } from 'src/app/user/order/budget/service/budget.service';

@Component({
    selector: 'apc-multi-action-buttons',
    templateUrl: './multi-actions.component.html',
    styleUrls: ['../action-buttons.component.scss'],
    providers: [BudgetService],
    standalone: false
})
export class AllActionsComponent implements OnInit {
  @Output() editEvent = new EventEmitter<boolean>(false);
  @Output() saveEvent = new EventEmitter<boolean>(false);
  @Output() cancelEvent = new EventEmitter<boolean>(false);
  @Output() deleteEvent = new EventEmitter<boolean>(false);
  @Output() deleteBudgetEvent = new EventEmitter<boolean>(false); //Evento speciale solo per delete budget
  @Output() cloneEvent = new EventEmitter<boolean>(false);
  @Output() fillFullTimeEvent = new EventEmitter<boolean>(false);
  @Output() newProductEvent = new EventEmitter<boolean>(false);
  @Output() newProjectEvent = new EventEmitter<boolean>(false);
  @Output() newBudgetFill = new EventEmitter<boolean>(false);
  @Output() createBudgetEvent = new EventEmitter<boolean>(false);
  @Output() refreshTitleEvent = new EventEmitter<boolean>(false);
  @Input() public edit: boolean = false;
  @Input() disableSave: boolean = false;
  @Input() disableDelete: boolean = false;
  @Input() hideExtraFields: boolean = false;
  @Input() hideClone: boolean = false;
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() personaSubsectionIdentifier: string;
  @Input() personaIdentifier: string;
  @Input() form: UntypedFormGroup;
  @Input() forms: UntypedFormArray;
  @Input() formId: string;
  @Input() deleteText: string = 'Are you sure to delete this item?';
  public deleteBudgetModalRef: any;

  public permissionHistory: Object = '';
  public permissionEdit: Object = '';
  public fillBudgetInfo: any;

  constructor(
    private readonly modalService: NgbModal,
    private readonly budgetService: BudgetService,
    private readonly toastService: ToastService
  ) {}

  ngOnInit(): void {
    let letLocalStorage = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.ROLE));
    let isAdmin = false;
    if(letLocalStorage != null && typeof letLocalStorage != typeof undefined){
      if(typeof letLocalStorage.role != typeof undefined){
        isAdmin = letLocalStorage.role.toLowerCase() == 'admin';
      }
    }
    
    this.permissionHistory = isAdmin ? null : { role: 'editor' };
    this.permissionEdit = isAdmin ? null : { role: 'editor' };
  }

  editForm(e?: any) {
    this.edit = !this.edit;
    setTimeout(() => {
      e && window.scrollTo({ top: e.layerY - 115, behavior: 'smooth' });
    }, 100);
    this.editEvent.emit(this.edit);
  }

  saveForm() {
    // if budgt section and new budget we have special save logic
    if (this.section === 'budget' && !this.personaSubsectionIdentifier) {
      this.budgetCreation();
    } else {
      this.saveEvent.emit(true);
    }
  }

  cancelForm() {
    if (this.form?.dirty) {
      const modalRef = this.modalService.open(ModalConfirmActionComponent);
      modalRef.componentInstance.message = 'modals.message.undoChangesMessage';
      modalRef.result.then((result) => {
        if (result) this.confirmCancelForm();
      });
    } else this.confirmCancelForm();
  }

  confirmCancelForm() {
    this.cancelEvent.emit(true);
    this.editForm();
  }

  cloneForm() {
    this.cloneEvent.emit(true);
  }

  fillFullTime() {
    this.fillFullTimeEvent.emit(true);
  }

  newProduct() {
    this.newProductEvent.emit(true);
  }

  delete() {
    // if budgt section and deleting budget we have special logic
    if (this.section === 'budget') {
      this.budgetDeletion();
    } else {
      this.deleteEvent.emit(true);
    }
  }

  newProject() {
    this.newProjectEvent.emit(true);
  }
  budgetFill() {
    this.newBudgetFill.emit(true);
  }

  async budgetCreation() {
    if(this.form.value.name === null || this.form.value.name?.trim() === ""){
      this.toastService.showError("Field Name is Mandatory", 5000);
      return;
    }
    if(this.form.value.type === null){
      this.toastService.showError("Field Type is Mandatory", 5000);
      return;
    }
    this.refreshTitleEvent.emit(true);
    // if budget with same name exists throw error
    if(this.forms.value.find(form => form.name === this.form.value.name && form.identifier !== this.form.value.identifier)) {
      this.toastService.showError("Budget with name '" + this.form.value.name + "' already exists in this order. Please change budget name.", 5000);
      return;
    }
    this.budgetService.getBudgetAvailableProducts(this.personaIdentifier).then((res) => {
      if (res) {
        this.fillBudgetInfo = this.modalService.open(BudgetCreationModalComponent, {
          ariaLabelledBy: 'modal-basic-info-budget',
          backdrop: 'static',
          keyboard: false,
          windowClass: 'modal-basic-info-budget',
        });
        this.fillBudgetInfo.componentInstance.modalRef = this.fillBudgetInfo;
        this.fillBudgetInfo.result.then(
          (res) => {},
          (res) => {
            // user wants to add all available products
            if (res) {
              this.createBudgetEvent.emit(true);
            } //no action required, standard save
            else {
              this.saveEvent.emit(true);
            }
          }
        );
      } else {
        this.saveEvent.emit(true);
      }
    });
  }

  async budgetDeletion() {
    this.deleteText = 'Are you sure to delete budget <b>' + this.form.value.name + '</b>?';
    let showProductsDecision = false;
    this.deleteBudgetModalRef = this.modalService.open(UnlinkProjectComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-filler-modal',
    });
    this.deleteBudgetModalRef.componentInstance.modalRef = this.deleteBudgetModalRef;

    if (this.form.value.budgetProducts.length > 0 && this.forms.value.length > 1) {
      this.deleteText =
        'You are about to delete a budget <strong>' +
        this.form.value.name +
        '</strong> with assigned products (' +
        this.form.value.budgetProducts.length +
        '). <br/> Do you want to release them back to the Order or migrate them to another Budget? <br/>';
      showProductsDecision = true;
      this.deleteBudgetModalRef.componentInstance.showProductsDecision = showProductsDecision;
      this.deleteBudgetModalRef.componentInstance.budgets = this.forms.value.filter(
        (el) => el.identifier !== this.form.value.identifier
      );
    }
    this.deleteBudgetModalRef.componentInstance.unlinkText = this.deleteText;

    // GESTIONE CORRETTA DEI RISULTATI DELLA MODALE
    this.deleteBudgetModalRef.result.then(
      (res: any) => {
        // 1. Spostiamo la logica qui dentro, perché la conferma fa scattare il "resolve" della Promise
        if (res && res.answer) {
          let budgetToMigrate = res.migrateId;
          let selectedMigrationBudgetName = res.selectedMigrationBudgetName;

          this.budgetService.deleteBudgetAndMigrateHours(this.form.value.identifier, res.migrateId).then((res: any) => {
            let formToRemove = this.forms.controls.findIndex(
              (el) => el.value.identifier === this.form.value.identifier
            );
            this.forms.removeAt(formToRemove);
            
            if (budgetToMigrate) {
              let formToUpdate = this.forms.controls.find((el) => el.value.identifier === res.identifier);
              formToUpdate.patchValue(res);
              this.toastService.showSuccess(
                'Budget deleted successfully! Assigned products from ' +
                  this.form.value.name +
                  ' got migrated to the budget ' +
                  selectedMigrationBudgetName
              );
            } else {
              this.toastService.showSuccess('Budget deleted successfully!');
            }
            this.deleteBudgetEvent.emit(true);
          });
        }
      }
    );
  }
}
